'use client';

import React from 'react';

import { IconSparkles } from '@/assets';
import ListAiModel from '@/contents/ai-model/list';
import ToolBar from './tools-bar';
import { Button, useDisclosure } from '@nextui-org/react';
import { toast } from 'react-toastify';
import { useAuth } from '@/provider/UserProvider';
import UploadModel from '@/components/upload-model';

const AiModel: React.FC = () => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const { isLogin } = useAuth();
  const handleAddModel = () => {
    if (!isLogin) return toast.warning('Please login to continue!');
    onOpen();
  }

  return (
    <div className="mx-10 pb-8 pt-[40px] md:mx-[20px] md:py-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <IconSparkles className="mr-2 sm:scale-80" />
          <p className="text-[24px] font-semibold leading-none sm:text-[20px]">Models</p>
        </div>
        <Button onClick={handleAddModel} className="rounded-full hidden sm:flex bg-primary text-[14px] h-10 sm:h-[36px] text-white">
          <span className="text-[22px] font-light">+</span> 
          <span className="font-medium sm:text-[13px]">Add Model</span>
        </Button>
      </div>
      <div className="mt-4 mb-7 w-full">
        <ToolBar />
      </div>
      <ListAiModel />
      <UploadModel isOpen={isOpen} onOpenChange={onOpenChange} />
    </div>
  );
};

export default AiModel;
